/**
 * SearchUtil - Shared utilities for search functionality
 */

// Shared debounce delay for search inputs (ms)
export const SEARCH_DEBOUNCE_DELAY = 500

/**
 * Creates a debounced search handler for class components
 * Provides manual timer management without lodash dependency
 *
 * @param callback - Function to call after debounce
 * @param delay - Debounce delay in ms (default: SEARCH_DEBOUNCE_DELAY)
 * @returns Object with trigger() and cancel() methods
 */
export function createDebouncedSearch(
    callback: () => void,
    delay: number = SEARCH_DEBOUNCE_DELAY
) {
    let timer: NodeJS.Timeout | null = null

    return {
        trigger: () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                callback()
                timer = null
            }, delay)
        },
        cancel: () => {
            if (timer) {
                clearTimeout(timer)
                timer = null
            }
        }
    }
}
